module.exports = __webpack_public_path__ + "img/23.274540ac.jpg";